/* eslint-disable camelcase */
import axios from "axios";

import ROUTES from "manager/config/apiRoutes";
import { IIntegrationStatuses } from "manager/interfaces/api";
import { API_URL } from "shared/lib/api/setupApi";

const api = {
  getIntegrationStatuses: () =>
    axios
      .get<IIntegrationStatuses>(`${API_URL}${ROUTES.getIntegrationStatuses}`)
      .then(({ data }) => data),

  testConnection: (
    provider: string,
    endpointUrl: string,
    username?: string,
    password?: string
  ) => {
    const payload = {
      provider,
      url: endpointUrl, // Backend expects 'url' which maps to 'endpoint_url'
      ...(username && { username }),
      ...(password && { password }),
    };

    const fullUrl = `${API_URL}${ROUTES.testConnectionEndpoint}`;

    return axios.post(fullUrl, payload).then(({ data }) => {
      return data;
    });
  },
  fetchLocations: (companyCode: string) => {
    const fullUrl = `${API_URL}${ROUTES.fetchLocationsEndpoint}`;
    return axios.get(fullUrl, { 
      params: { company_code: companyCode },
      returnRaw: true  // Bypass axios interceptor to get full response with success field
    } as any).then(({ data }) => {
      return data;
    });
  },
  getCosignConnectInfo: () =>
    axios
      .get(`${API_URL}${ROUTES.cosignConnectInfo}`)
      .then(({ data }) => data),
  activateCosign: () =>
    axios
      .post(`${API_URL}${ROUTES.cosignActivate}`)
      .then(({ data }) => data),
  createCosignPropertyManager: (name?: string) =>
    axios
      .post(
        `${API_URL}${ROUTES.cosignCreatePropertyManager}`,
        name ? { name } : {}
      )
      .then(({ data }) => data),
  connectExistingCosignAccount: (propertyManagerUuid: string) =>
    axios
      .post(`${API_URL}${ROUTES.cosignConnectExisting}`, {
        property_manager_uuid: propertyManagerUuid,
      })
      .then(({ data }) => data),
  mapExistingCosignProperty: (payload: {
    vero_property_id: number;
    cosign_property_uuid: string;
  }) =>
    axios
      .post(`${API_URL}${ROUTES.cosignPropertyMappings}`, payload)
      .then(({ data }) => data),
  listCosignProperties: () =>
    axios
      .get(`${API_URL}${ROUTES.cosignProperties}`)
      .then(({ data }) => data),
  createCosignProperty: (payload: {
    vero_property_id: string;
    name: string;
    address: string;
    city: string;
    state: string;
    zip_code: string;
    units: number;
  }) =>
    axios
      .post(`${API_URL}${ROUTES.cosignProperties}`, payload)
      .then(({ data }) => data),
  getCosignPropertyMappings: () =>
    axios
      .get(`${API_URL}${ROUTES.cosignPropertyMappings}`)
      .then(({ data }) => data),
  updateCosignPropertyManagerUuid: (propertyManagerUuid: string) =>
    axios
      .patch(`${API_URL}${ROUTES.cosignPropertyManagerUuid}`, {
        property_manager_uuid: propertyManagerUuid,
      })
      .then(({ data }) => data),
};

export default api;
